export const initiateContactVerificationUrl = () => "/verifications/initiate";

export const confirmContactVerificationUrl = () => "/verifications/confirm";
